<template>
  <div>
    <div
      v-if="isInSchedule"
      class="video-wrapper"
    >
      <video
        ref="posonVideo"
        class="video-bg"
        autoplay
        muted
        loop
        playsinline
        disablepictureinpicture
        @canplaythrough="handleVideoLoad"
      >
        <source
          src="@/assets/videos/posonbanner.mp4"
          type="video/mp4"
        >
      </video>

      <img
        v-if="videoLoaded"
        class="left-image"
        src="@/assets/images/pages/poson.png"
      >
      <img
        v-if="videoLoaded"
        class="left-image2"
        src="@/assets/images/pages/happyposonday.png"
      >
    </div>
    <div v-else>
      <div
        class="greeting-page"
      >
        <div class="greeting-section">
          <h1>{{ greeting }}!</h1>
          <p>Hello {{ currentUser ? currentUser.first_name : '' }}, Welcome Back</p>
        </div>
        <div class="image-section">
          <div class="shape shape-top" />
          <img
            src="@/assets/images/pages/welcome.svg"
            alt="Delivery Illustration"
            class="illustration"
          >
          <div class="shape shape-bottom" />
          <div class="welcome-footer">
            Powered by CURFOX Delivery Management
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {
  mapGetters,
} from 'vuex'
import { tenant } from '@/constants/config'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const BusinessRepository = RepositoryFactory.get('businessSetting')

export default {
  data() {
    return {
      greeting: this.getGreeting(),
      tenant,
      form: {},
      now: new Date(),
      timer: null,
      startTime: new Date('2026-06-29T00:00:00+05:30'),
      endTime: new Date('2026-06-30T00:00:00+05:30'),
      videoLoaded: false,
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    isRoyalTenant() {
      return this.tenant === 'royalexpress'
    },
    isInSchedule() {
      return this.now >= this.startTime && this.now <= this.endTime
    },
  },
  async mounted() {
    await this.fetchBusinessSettings()
    this.timer = setInterval(() => {
      this.now = new Date()
    }, 1000)
    if (this.$refs.posonVideo && this.$refs.posonVideo.readyState >= 4) {
      this.videoLoaded = true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async fetchBusinessSettings() {
      try {
        this.loading = true
        this.form = localStorage.getItem('businessSettings') ? JSON.parse(localStorage.getItem('businessSettings')) : (await BusinessRepository.getbusinessSettingsResource()).data.data
        if (!localStorage.getItem('businessSettings')) localStorage.setItem('businessSettings', JSON.stringify(this.form))
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    getGreeting() {
      const currentHour = new Date().getHours()
      if (currentHour >= 5 && currentHour < 12) {
        return 'Good Morning'
      } if (currentHour >= 12 && currentHour < 18) {
        return 'Good Afternoon'
      }
      return 'Good Evening'
    },
    handleVideoLoad() {
      this.videoLoaded = true
    },
  },
}
</script>

<style scoped>
/* Import Fonts (You can also move this to your index.html) */
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Montserrat:wght@300;400&display=swap');
.festive-container {
  position: relative;
  width: 100%;
  height: 650px; /* Adjust height as needed */
  background: linear-gradient(to bottom, #532540, #FD326C);
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  color: white;
  border-radius: 5px;
}
/* --- Background Stars (Simulated with CSS) --- */
.star-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Settings for the snow image */
  background-repeat: repeat;
  background-position: center top;
  background-size: cover; /* Ensures it covers the area */
  opacity: 0.8; /* Adjust based on how bright your snow png is */
  pointer-events: none;
}
/* --- Text Styling --- */
.text-content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 50px 80px 0 80px;
}
.main-title {
  font-family: 'Great Vibes', cursive; /* Script font */
  font-size: 3.2rem;
  font-weight: 400;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  letter-spacing: 1px;
  color:#ffffff;
}
.sub-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  font-weight: 400;
  margin-top: 5px;
  opacity: 0.9;
  letter-spacing: 0.5px;
}
/* --- Bells Styling --- */
.bells-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
}
.bells-img {
  width: 150px; /* Adjust based on your image size */
  height: auto;
  filter: drop-shadow(0 5px 10px rgba(0,0,0,0.3));
}
/* --- The Curved Background Layers --- */
.curves-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}
/* The Pink Band */
.curve-pink {
  position: absolute;
  bottom: -60%; /* Pushes the circle down to create the arch */
  left: -10%;
  width: 120%;
  height: 120%;
  background: #E03064; /* Pink color */
  border-radius: 50%; /* Creates the curve */
}
.curve-light-pink {
  position: absolute;
  bottom: -65%; /* Pushes the circle down to create the arch */
  left: -10%;
  width: 120%;
  height: 120%;
  background: #FFC0D3; /* Pink color */
  border-radius: 50%; /* Creates the curve */
}
/* The White Area */
.curve-white {
  position: absolute;
  bottom: -70%;
  left: -10%;
  width: 120%;
  height: 120%;
  background: #ffffff;
  border-radius: 50%;
}
/* --- Santa Center Image --- */
.santa-container {
  position: absolute;
  bottom: 15%; /* Adjust to overlap the curve correctly */
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  display: flex;
  justify-content: center;
}
.santa-img {
  width: 380px; /* Adjust based on your Santa image size */
  height: auto;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.2));
}
.video-wrapper {
  width: 100%;
  display: flex;
  position: relative;
}

.video-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.left-image {
  position: absolute;
  left: 30%;
  top: 35%;
  transform: translateY(-50%);
  width: 40%;
  z-index: 2;
}

.left-image2 {
  position: absolute;
  left: 37.5%;
  top: 42%;
  transform: translateY(-50%);
  width: 25%;
  z-index: 2;
}

/* --- Responsive Adjustments --- */
@media (max-width: 768px) {
  .festive-container {
    height: 500px;
  }
  .main-title {
    font-size: 1.8rem;
  }
  .sub-title {
    font-size: 0.8rem;
  }
  .bells-img {
    width: 100px;
  }
  .santa-img {
    width: 280px;
  }
  .text-content {
    padding: 50px 70px 0 70px;
  }
}
.greeting-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f8fa;
  box-sizing: border-box;
  overflow: hidden; /* Prevent scrolling */
}

.greeting-section {
  flex: 1;
  margin-left: 5%;
}

.greeting-section h1 {
  font-size: 2.5em;
  margin: 0;
  color: #333;
}

.greeting-section p {
  font-size: 1.2em;
  color: #777;
  margin-top: 10px;
  font-weight: 500;
}

.image-section {
  flex: 1;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%; /* Ensures it adjusts to the height of the container */
}

.illustration {
  max-width: 100%;
  max-height: 100%; /* Ensure it scales down if needed */
  z-index: 2;
  padding-right: 5%;
}

.shape {
  position: absolute;
  background-color: #3498db;
  border-radius: 50%;
  opacity: 0.3;
}

.shape-top {
  width: 50vw;
  height: 50vw;
  top: -35vh;
  left: -30vw;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.shape-bottom {
  width: 50vw;
  height: 50vw;
  top: 5vh;
  left: -15vw;
  z-index: 1;
  transform: translate(-50%, 50%);
}

.welcome-footer {
  text-align: right;
  font-size: 0.9em;
  color: #000000;
  width: 100%;
  font-weight: 500;
  padding: 20px;
}
@media (max-width: 768px) {
  .greeting-page {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }

  .greeting-section {
    margin-left: 0;
    text-align: center;
    margin-bottom: 20px;
  }

  .greeting-section h1 {
    font-size: 1.8em;
  }

  .greeting-section p {
    font-size: 1em;
  }

  .image-section {
    padding: 0 10px;
  }

  .illustration {
    max-width: 100%;
    max-height: auto;
    padding-right: 0;
  }

  .shape-top {
    width: 40vw;
    height: 40vw;
    top: -5vh;
    left: -10vw;
  }

  .shape-bottom {
    width: 40vw;
    height: 40vw;
    bottom: 0vh;
    left: 0vw;
    transform: translate(200%, 60%);
  }

  .welcome-footer {
    text-align: center;
    font-size: 0.8em;
    padding: 10px;
  }
}
</style>
